module.exports = __webpack_public_path__ + "img/US_WoodGatherRate_ua.4df8cfe0.webp";